// src/layouts/navigation/verify-gallery/components/ProgressBar.jsx
import "./styles/ProgressBar.css";

export default function ProgressBar({ current, total, label }) {
  const percentage = Math.min((current / total) * 100, 100);

  return (
    <div className="verify-gallery__progress-container">
      <div className="verify-gallery__progress-track">
        <div
          className="verify-gallery__progress-fill"
          style={{ width: `${percentage}%` }}
        />
      </div>
      <p className="verify-gallery__progress-label">
        {label ?? `${current} of ${total} artworks uploaded`}
      </p>
    </div>
  );
}
